<template>
  <div>
    <!-- 面包屑导航 -->
    <Breadcrumb :levelList="levelList"/>
    <div class="aibfb aimt20 pull-left">
      <div class="entity_sysSearchOne pull-right">
        <el-input placeholder="添加关键字" class="selectInput pull-right" v-model="entity_ruleSearch" size="small">
          <svg slot="suffix" class="icon" aria-hidden="true">
            <use xlink:href="#iconsearchicon" />
          </svg>
        </el-input>
      </div>
      <el-select class="pull-right aimr10 entity_w130" size="small" v-model="entity_ruleSelectOne" placeholder="所有状态">
        <el-option label="已启用" value="1">已启用</el-option>
        <el-option label="已禁用" value="2">已禁用</el-option>
      </el-select>
      <el-select class="pull-right aimr10 entity_w130" size="small" v-model="entity_ruleSelectTwo" placeholder="请选择">
        <el-option label="已启用" value="1">正则规则</el-option>
        <el-option label="已禁用" value="2">定位词规则</el-option>
      </el-select>
    </div>
    <div class="aibfb pull-left aimt10 entity_sysListBox">
      <div class="entity_sysList">
        <div class="entity_sysListAdd text-center" style="width: 200px">
         <!-- <div class="aibfb50 pull-left entity_ruleBorder" @click="drawerAddLocation = true">
            <span class="iconfont icon-xinzeng"></span>
            <div class="entity_sysListAddTxt">添加定位词规则</div>
          </div>-->
          <div class="aibfb50 pull-right" @click="addRuleEntity">
            <span class="iconfont icon-xinzeng"></span>
            <div class="entity_sysListAddTxt">添加正则规则</div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="entity_sysList" v-for="entity in ruleData" :key="entity.name">
        <div class="entity_sysListTop">
          <div class="entity_sysListImg">
            <img :src="showPath+'/res/download/entity/idx/show?url='+entity.image" style="height: 100%">
          </div>
          <div class="entity_sysListTxt">
            <div class="entity_sysListTxtTitle">{{ entity.name }}</div>
            <div class="entity_sysListTagBox">
              <span>规则表达式:</span>
              <p>{{ entity.rule }}</p>
            </div>
          </div>
        </div>
        <div class="entity_sysListBottom">
          <ul>
            <li v-if="entity.enable" style="background-color: #9f9f9f;">
              <el-tooltip content="测试" placement="bottom" effect="light">
                <span class="iconfont icon-bug"></span>
              </el-tooltip>
            </li>
            <li @click="openDebugPage(entity.name)" v-else>
              <el-tooltip content="测试" placement="bottom" effect="light">
                <span class="iconfont icon-bug"></span>
              </el-tooltip>
            </li>
            <li class="entity_sysDisableCp" v-if="entity.enable" @click="editEnable(entity.id,entity.name,entity.rule,0)" style="background-color: #9f9f9f;">
              <el-tooltip content="启用" placement="bottom" effect="light">
                <span class="iconfont icon-suoguan"></span>
              </el-tooltip>
            </li>
            <li class="entity_sysDisableCp" v-else @click="editEnable(entity.id,entity.name,entity.rule,1)">
              <el-tooltip content="禁用" placement="bottom" effect="light">
                <span class="iconfont icon-suokai"></span>
              </el-tooltip>
            </li>
            <li class="entity_sysDisableLi entity_sysDisableCp" @click="delRuleEntity(entity)">
              <el-tooltip content="删除" placement="bottom" effect="light">
                <span class="iconfont icon-table-delete"></span>
              </el-tooltip>
            </li>
            <li class="entity_sysDisableLi entity_sysDisableCp" @click="updateRuleEntity(entity)">
              <el-tooltip content="编辑" placement="bottom" effect="light">
                <span class="iconfont icon-table-bianji"></span>
              </el-tooltip>
            </li>
          </ul>
        </div>
        <div class="clearfix"></div>
      </div>
      <!-- page -->
      <Page v-bind:init_item="pageBuild" @currentPage="currentPage"/>
    </div>
    <!----***********测试***********----->
    <el-dialog class="entity_sysDialog" title="" :visible.sync="dialogRuleTest" width="480px">
      <div class="aibfb pull-left entity_sysDialog_title">
        <span>请输入{{this.test_name}}：</span><a href="javaScript:;">随机示例</a>
      </div>
      <div class="aibfb pull-left">
        <el-input v-model="entity_sysDialogInput" @keyup.enter.native="debugRuleEntityQuestion" size="small">
          <el-button slot="append" size="small" @click="debugRuleEntityQuestion">发送</el-button>
        </el-input>
      </div>
      <div class="aibfb pull-left aimt10 entity_sysDialog_title">
        <span>分析结果：</span>
      </div>
      <div class="aibfb pull-left entity_sysDialog_card aimb10">
        <div class="aibfb pull-left entity_sysDialog_cardblue">
          <span class="icon-pipei iconfont"></span>
          匹配到规则实体
        </div>
        <div class="aibfb pull-left">
          <span v-for="(str,index) in debugList" :key="str">实体{{index+1}}：<p>{{str}}</p></span>
        </div>
      </div>
      <div class="clearfix"></div>
    </el-dialog>
    <!----***********新增正则规则***********----->
    <el-drawer class="entity_drawerBox" :title="title" :wrapperClosable="false" :visible.sync="drawerAddRegular" size="450px">
        <div class="aibfb pull-left entity_drawerBtnHeader">
          <el-button class="pull-left" type="primary" size="small" @click="saveRule('entity_drawerAddRegularForm')">保 存</el-button>
          <el-switch class="pull-right" v-model="entity_drawerAddRegularForm.enable" active-text="已启用" inactive-text="未启用"></el-switch>
        </div>
        <div class="aibfb pull-left entity_drawerEditCon">
          <el-form size="small" ref="entity_drawerAddRegularForm" :rules="rules" :model="entity_drawerAddRegularForm" label-width="90px">
            <el-form-item label="实体名称" prop="name">
              <el-input v-model="entity_drawerAddRegularForm.name" :disabled="isEdit" size="small"></el-input>
            </el-form-item>
            <el-form-item label="图标">
              <div class="aibfb pull-left">
                <el-upload
                  class="entity_upload-demo"
                  ref="rule_entity_upload"
                  :auto-upload="false"
                  name="files"
                  :data="entity_drawerAddRegularForm"
                  accept="image/*"
                  :action="uploadUrl"
                  :headers="headers"
                  :on-change="uploadChange"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :on-remove="handleRemove"
                  :limit="1"
                  :file-list="fileList"
                  list-type="picture">
                  <el-button size="small" type="info" icon="el-icon-plus">上传图片</el-button>
                  <div slot="tip" class="el-upload__tip">*建议尺寸50px*50px，jpg/png/bmp/gif格式</div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="规则表达式" prop="rule">
              <el-input class="entity_drawerAddRegularTextarea" type="textarea" v-model="entity_drawerAddRegularForm.rule" value="[1-9]([0-9]{5,11})]"></el-input>
            </el-form-item>
          </el-form>
        </div>
    </el-drawer>
    <!----***********新增定位词规则***********----->
    <el-drawer class="entity_drawerBox" title="" :visible.sync="drawerAddLocation" size="450px">
      <div class="aibfb pull-left entity_drawerBtnHeader">
        <el-button class="pull-left" type="primary" size="small">保 存</el-button>
        <el-switch class="pull-right" v-model="entity_drawerAddLocationSwitch" active-text="已启用" inactive-text="未启用"></el-switch>
      </div>
      <div class="aibfb pull-left entity_drawerEditCon">
        <el-form size="small" ref="entity_drawerAddLocationForm" :model="entity_drawerAddLocationForm" label-width="90px">
          <el-form-item label="实体名称">
            <el-input v-model="entity_drawerAddLocationForm.name" size="small"></el-input>
          </el-form-item>
          <el-form-item label="图标">
            <div class="aibfb pull-left">
              <el-upload class="entity_upload-demo" accept="image/*" action="https://jsonplaceholder.typicode.com/posts/" :limit="1"
                         :file-list="fileList" list-type="picture">
                <el-button size="small" type="info" icon="el-icon-plus">上传图片</el-button>
                <div slot="tip" class="el-upload__tip">*建议尺寸50px*50px，jpg/png/bmp/gif格式</div>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="规则内容">
            <div class="entity_drawerAddLocationText">
              <span class="spantxt">提取</span>
              <el-tag size="mini" effect="plain" closable>第一次</el-tag>
              <span class="spantxt">出现</span>
              <el-tag size="mini" effect="dark" closable>地址</el-tag>
            </div>
          </el-form-item>
          <el-form-item label="目标词">
            <div class="entity_drawerAddLocationInput">
              <el-cascader class="aibfb" size="mini" placeholder="" :options="optionsTarget" :props="{ multiple: false }" filterable clearable></el-cascader>
            </div>
          </el-form-item>
          <el-form-item label="提取规则">
            <div class="entity_drawerSwitch">
              <el-switch v-model="entity_drawerAddLocationSwitchTwo" active-text="已启用" inactive-text="未启用"></el-switch>
              <div class="aibfb pull-left pst">
                <div class="maskBg"></div>
                <el-tabs class="entity_drawerAddLocationTabs" v-model="entity_drawerActiveName">
                  <el-tab-pane label="根据辅助词" name="one">
                    <div class="entity_drawerAddLocationTabsBox">
                      <div class="aibfb pull-left">
                        <span class="el-tagSpan pull-left">在目标词</span>
                        <el-select class="pull-left entity_w80" size="small" v-model="entity_drawerAddLocationFirst" placeholder="前">
                          <el-option label="前" value="1">前</el-option>
                          <el-option label="后" value="2">后</el-option>
                        </el-select>
                      </div>
                      <div class="aibfb pull-left aimt10">
                        <div class="entity_sysSearchOne pull-right" style="width:100%;">
                          <el-input placeholder="到达" class="selectInput pull-right" v-model="entity_drawerAddLocationInput1" size="small">
                            <span slot="suffix" class="iconfont icon-xinzeng"></span>
                          </el-input>
                        </div>
                      </div>
                      <div class="aibfb pull-left aimt10">
                        <div class="entity_sysSearchOne pull-right" style="width:100%;">
                          <el-input placeholder="返回" class="selectInput pull-right" v-model="entity_drawerAddLocationInput2" size="small">
                            <svg slot="suffix" class="icon text-danger" aria-hidden="true">
                              <use xlink:href="#icontable-delete" />
                            </svg>
                          </el-input>
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="根据目标词出现的次数" name="two">
                    <div class="aibfb pull-left aimt10">
                      <span class="el-tagSpan pull-left aimr10">只提取对应</span>
                      <span class="el-tagSpan pull-left">第</span>
                      <el-select class="pull-left entity_w65" size="small" v-model="entity_drawerAddLocationTwo" placeholder="1">
                        <el-option label="1" value="1">1</el-option>
                        <el-option label="2" value="2">2</el-option>
                        <el-option label="3" value="3">3</el-option>
                        <el-option label="4" value="4">4</el-option>
                      </el-select>
                      <span class="el-tagSpan pull-left">次出现的目标词</span>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Breadcrumb from '@/views/components/crm/Breadcrumb'
import Page from '@/views/entity/components/PageComponent.vue'
import { queryRuleEntity, deleteRuleEntity, updateRuleEntityEnable, debugRuleEntity, updateRuleEntity } from '@/api/entity/ruleEntity.js'
export default {
  components: { Breadcrumb, Page },
  data() {
    return {
      levelList: [{ path: '@/views/entity/system', title: '规则类实体' }],
      entity_drawerAddLocationInput1: '',
      entity_drawerAddLocationInput2: '',
      entity_drawerAddLocationInput3: '',
      entity_drawerAddLocationInput4: '',
      entity_drawerActiveName: 'one',
      entity_drawerAddLocationFirst: '',
      entity_drawerAddLocationTwo: '',
      dialogRuleTest: false,
      drawerAddRegular: false,
      drawerAddLocation: false,
      entity_drawerAddLocationForm: {
        name: '出发城市',
        id: '[1-9]([0-9]{5,11})]'
      },
      debugList: [],
      showPath: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_ENTITY_SERVICE'),
      entity_drawerAddLocationSwitch: '',
      entity_drawerAddLocationSwitchTwo: '',
      entity_drawerAddRegularForm: {
        id: '',
        name: 'demo',
        rule: '[1-9]([0-9]{5,11})]',
        enable: false
      },
      rules: {
        name: [
          { required: true, message: '请填写实体名称', trigger: 'blur' }
        ],
        rule: [
          { required: true, message: '请填写规则表达式', trigger: 'blur' }
        ]
      },
      isEdit: true,
      ruleData: [],
      title: '新增实体',
      isAdd: false,
      fileList: [{ name: '', url: '' }],
      oldUrl: '',
      uploadUrl: '',
      headers: { Authorization: this.getToken(), 'X-TENANT-ID': this.getCTenantId() },
      pageBuild: {
        page_size: 5,
        total: 0,
        currentPage: 1
      },
      test_name: '',
      entity_ruleSearch: '',
      entity_sysDialogInput: '',
      entity_ruleSelectOne: '',
      entity_ruleSelectTwo: '',
      optionsTarget: [{
        value: 'chengshiming',
        label: '城市名'
      }, {
        value: 'zhinan',
        label: '指南'
      }]
    }
  },
  methods: {
    uploadChange(file, fileList) {
      if (length === 0) {
      }
      const isLt2M = file.size / 1024 / 1024 > 2
      if (isLt2M) {
        window.entityMessage({ type: 'warning', text: '上传文件大小不能超过2M' })
        this.$refs.rule_entity_upload.clearFiles()
      }
      fileList[0] = file
      this.fileList[0] = file
    },
    getToken() {
      return localStorage.getItem('Authorization')
    },
    // 获取租户id
    getCTenantId() {
      return localStorage.getItem('X-TENANT-ID')
    },
    handleSuccess (response, file, fileList) {
      if (response.code === 2000) {
        window.entityMessage({ type: 'success', text: response.msg })
      } else {
        window.entityMessage({ type: 'warning', text: response.msg })
      }
      this.drawerAddRegular = false
      this.cleanFile()
      this.currentPage(this.pageBuild.currentPage)
    },
    handleError (err) {
      if (err.data.msg) {
        window.entityMessage({ type: 'warning', text: err.msg })
      } else {
        window.entityMessage({ type: 'warning', text: err.msg })
      }
      this.drawerAddRegular = false
      this.cleanFile()
      this.currentPage(this.pageBuild.currentPage)
    },
    handleRemove(file, fileList) {
      this.fileList = []
    },
    cleanFile() {
      this.entity_drawerAddRegularForm.name = ''
      this.entity_drawerAddRegularForm.rule = ''
      this.entity_drawerAddRegularForm.enable = false
      this.$refs.rule_entity_upload.clearFiles()
    },
    saveRule(formName) {
      var that = this
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (''.match(that.entity_drawerAddRegularForm.rule)) {
            window.entityMessage({ type: 'warning', text: '错误的表达式' + that.entity_drawerAddRegularForm.rule + '，应保证空串不能匹配' })
            return false
          }
          // console.log(that.fileList)
          if (that.fileList.length === 0) {
            window.entityMessage({ type: 'warning', text: '图标不能为空' })
            return false
          }
          if (that.entity_drawerAddRegularForm.enable) {
            that.entity_drawerAddRegularForm.enable = 0
          } else {
            that.entity_drawerAddRegularForm.enable = 1
          }
          if (that.fileList[0].url === that.oldUrl) {
            updateRuleEntity(that.entity_drawerAddRegularForm).then(res => {
              if (res.data.code === 2000) {
                window.entityMessage({ type: 'success', text: res.data.msg })
              } else {
                window.entityMessage({ type: 'warning', text: res.data.msg })
              }
              this.drawerAddRegular = false
              this.currentPage(this.pageBuild.currentPage)
            }).catch(err => {
              window.entityMessage({ type: 'warning', text: err.data.msg })
              this.drawerAddRegular = false
              this.currentPage(this.pageBuild.currentPage)
            })
          } else {
            that.$refs.rule_entity_upload.submit()
          }
        } else {
          return false
        }
      })
    },
    addRuleEntity() {
      this.title = '新增实体'
      this.entity_drawerAddRegularForm.name = ''
      this.entity_drawerAddRegularForm.rule = ''
      this.entity_drawerAddRegularForm.enable = false
      this.drawerAddRegular = true
      this.uploadUrl = window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_ENTITY_SERVICE') + '/entity/addRuleEntity'
      this.isEdit = false
      this.fileList = []
    },
    updateRuleEntity(data) {
      this.title = '编辑实体'
      this.drawerAddRegular = true
      this.uploadUrl = window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_ENTITY_SERVICE') + '/entity/updateRuleEntity'
      this.isEdit = true
      this.entity_drawerAddRegularForm.id = data.id
      this.entity_drawerAddRegularForm.name = data.name
      this.entity_drawerAddRegularForm.rule = data.rule
      this.entity_drawerAddRegularForm.enable = data.enable === 0
      this.fileList = [{ name: data.imageName, url: this.showPath + '/res/download/entity/idx/show?url=' + data.image }]
      this.oldUrl = this.fileList[0].url
    },
    currentPage(currentPage) {
      var that = this
      that.pageBuild.currentPage = currentPage
      that.searchDate(that.pageBuild.page_size, currentPage)
    },
    searchDate(limit, page) {
      var that = this
      queryRuleEntity({ name: that.entity_ruleSearch, page: page, limit: limit }).then(res => {
        if (res.data.code === 2000) {
          that.ruleData = res.data.data.root
          that.pageBuild.total = res.data.data.totalProperty
        }
      }).catch(err => {
        window.entityMessage({ type: 'warning', text: err.data.msg })
        that.currentPage(1)
      })
    },
    delRuleEntity(data) {
      var that = this
      deleteRuleEntity(data).then(res => {
        if (res.data.code === 2000) {
          window.entityMessage({ type: 'success', text: res.data.msg })
        } else {
          window.entityMessage({ type: 'warning', text: res.data.msg })
        }
        that.currentPage(1)
      }).catch(err => {
        window.entityMessage({ type: 'warning', text: err.data.msg })
        that.currentPage(1)
      })
    },
    editEnable(id, name, rule, enable) {
      var that = this
      updateRuleEntityEnable({ id: id, name: name, rule: rule, enable: enable }).then(res => {
        if (res.data.code === 2000) {
          window.entityMessage({ type: 'success', text: res.data.msg })
        } else {
          window.entityMessage({ type: 'warning', text: res.data.msg })
        }
        that.currentPage(that.pageBuild.currentPage)
      }).catch(err => {
        window.entityMessage({ type: 'warning', text: err.data.msg })
        that.currentPage(that.pageBuild.currentPage)
      })
    },
    openDebugPage(name) {
      this.test_name = name
      this.entity_sysDialogInput = ''
      this.debugList = []
      this.dialogRuleTest = true
    },
    debugRuleEntityQuestion() {
      var that = this
      this.debugList = []
      if (that.entity_sysDialogInput.length > 0) {
        debugRuleEntity({ name: that.test_name, content: that.entity_sysDialogInput }).then(res => {
          if (res.data.code === 2000) {
            this.debugList = res.data.data
          } else {
            window.entityMessage({ type: 'warning', text: res.data.msg })
          }
        }).catch(err => {
          window.entityMessage({ type: 'warning', text: err.data.msg })
        })
      } else {
        window.entityMessage({ type: 'warning', text: '请输入内容' })
      }
    }
  },
  mounted() {
    this.currentPage(1)
  }
}
</script>
<style>
</style>
